// extracted by mini-css-extract-plugin
export default {"pageWrap":"Wb-z","fullWidth":"Xb-z","heading":"Yb-z","fullBleed":"Zb-z","hidden":"_b-z"};